import { render, staticRenderFns } from "./ArticleBulkAction.vue?vue&type=template&id=d1983f92&"
import script from "./ArticleBulkAction.vue?vue&type=script&lang=js&"
export * from "./ArticleBulkAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports